// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CountryContext from "./CountryContext.bs.js";

var make = CountryContext.context.Provider;

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

export {
  make ,
  makeProps ,
  
}
/* make Not a pure module */
